// extracted by mini-css-extract-plugin
module.exports = {"root":"AppSection_root__nMgdD","appStore":"AppSection_appStore__mEI1q","playStore":"AppSection_playStore__2tnfa"};